export default "__VITE_ASSET__C3WZv5A3__"